import { request } from './core';

export interface Package {
  ID: string;
  UserID: string;
  Name: string;
  Description: string;
  PriceCents: number;
  Currency: string;
  IsPublic: boolean;
  SortOrder: number;
  CreatedAt: string;
  UpdatedAt: string;
}

export const packagesApi = {
  listPackages: () => request<Package[]>("GET", "/api/v1/packages"),
  createPackage: (p: { name: string; description?: string; price_cents: number; currency?: string; is_public?: boolean }) =>
    request<Package>("POST", "/api/v1/packages", p),
  updatePackage: (id: string, p: { name?: string; description?: string; price_cents?: number; is_public?: boolean; sort_order?: number }) =>
    request<Package>("PUT", `/api/v1/packages/${encodeURIComponent(id)}`, p),
  deletePackage: (id: string) => request<void>("DELETE", `/api/v1/packages/${encodeURIComponent(id)}`),
  reorderPackages: (ids: string[]) => request<void>("PUT", "/api/v1/packages/order", { package_ids: ids }),
};
